import React, { useEffect, useState } from 'react'

const LottiePlayer = props => {
  const [PlayerComponent, setPlayerComponent] = useState(null)

  useEffect(() => {
    import('@lottiefiles/react-lottie-player').then(module => {
      setPlayerComponent(() => module.Player)
    })
  }, [])

  if (!PlayerComponent) return null

  return <PlayerComponent {...props} />
}

export default LottiePlayer
